import React, { useState } from 'react'

// estilos
import './buscar.css'
import imgLupa from './lupa.svg'
import imgFiltros from './filtros.svg'
import { Popover } from '@mui/material'
import { ContactFilters } from './filterList/ContactFilters'

export const Buscar = ({ searching, setSearching }) => {

  const { placeholder } = searching

  const handleChange = ({ target }) => {

    setSearching({
      ...searching,
      filters: {
        ...searching.filters,
        [target.name]: target.value,
        buscar: true
      }
    })

  }

  return (
    <div className='p-buscar'>
      <img className='p-buscar-lupa' src={imgLupa} alt="buscar" htmlFor="buscador" />

      <input
        type="text"
        placeholder={placeholder || 'Buscar...'}
        id='buscador'
        name='text'
        onChange={handleChange}
      />

      <DropdownFilters
        searching={searching}
        setSearching={setSearching}
      />

    </div>
  )
}

const DropdownFilters = ({ searching, setSearching }) => {

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <img aria-describedby={id} variant="contained" className='p-buscar-filtros' src={imgFiltros} alt="filtros" onClick={handleClick} />
      <Popover
        className='p-popover-buscar-filtros'
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >

        <ContactFilters
          searching={searching}
          setSearching={setSearching}
        />

      </Popover>
    </div>
  )

}
